import {
  SAVE_COMPANY_REVIEW,
  SAVE_COMPANY_REVIEW_ERROR,
  SAVE_COMPANY_REVIEW_SUCCESS,

  GET_COMPANY_REVIEW,
  GET_COMPANY_REVIEW_ERROR,
  GET_COMPANY_REVIEW_SUCCESS,

  GET_COMPANY,
  GET_COMPANY_ERROR,
  GET_COMPANY_SUCCESS,

  SET_RATINGS,
  SET_RATINGS_ERROR,
  SET_RATINGS_SUCCESS,

  DELETE_COMPANY,
  DELETE_COMPANY_ERROR,
  DELETE_COMPANY_SUCCESS,

  GET_CATEGORY,
  GET_CATEGORY_ERROR,
  GET_CATEGORY_SUCCESS,

  DELETE_CATEGORY,
  DELETE_CATEGORY_ERROR,
  DELETE_CATEGORY_SUCCESS,

  CREATE_CATEGORY,
  CREATE_CATEGORY_ERROR,
  CREATE_CATEGORY_SUCCESS,

  GET_CATEGORY_BYID,
  GET_CATEGORY_BYID_ERROR,
  GET_CATEGORY_BYID_SUCCESS,

  CLEAR_COMPANY_REVIEW,
} from './constants';

export default {
  [CLEAR_COMPANY_REVIEW](state) {
    state.company = {
      companyName: '',
      address: null,
      email: null,
      phoneNumber: null,
      comments: '',
      rating: null,
    };
  },

  [DELETE_COMPANY](state) {
    state.error = false;
    state.loading = true;
  },
  [DELETE_COMPANY_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [DELETE_COMPANY_SUCCESS](state) {
    state.company = false;
    state.loading = false;
  },
  [SAVE_COMPANY_REVIEW](state) {
    state.error = false;
    state.success = false;
    state.formLoading = true;
  },
  [SAVE_COMPANY_REVIEW_ERROR](state, payload) {
    state.error = payload;
    state.formLoading = false;
  },
  [SAVE_COMPANY_REVIEW_SUCCESS](state, payload) {
    state.companies = payload;
    state.success = true;
    state.formLoading = false;
  },

  [SET_RATINGS](state) {
    state.error = false;
    state.success = false;
    state.formLoading = true;
  },
  [SET_RATINGS_ERROR](state, payload) {
    state.error = payload;
    state.formLoading = false;
  },
  [SET_RATINGS_SUCCESS](state, payload) {
    state.ratings = payload;
    state.success = true;
    state.formLoading = false;
  },


  [GET_COMPANY_REVIEW](state) {
    state.error = false;
    state.loading = true;
  },
  [GET_COMPANY_REVIEW_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_COMPANY_REVIEW_SUCCESS](state, payload) {
    state.companies = payload.data;
    state.paging = payload.paging;
    state.loading = false;
  },

  [GET_COMPANY](state) {
    state.company = false;
    state.error = false;
    state.loading = true;
    state.success = false;
  },
  [GET_COMPANY_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_COMPANY_SUCCESS](state, payload) {
    state.company = payload;
    state.loading = false;
  },

  [DELETE_CATEGORY](state) {
    state.success = false;
    state.error = false;
    state.loading = true;
  },
  [DELETE_CATEGORY_ERROR](state, payload) {
    state.error = payload;
    state.success = false;
    state.loading = false;
  },
  [DELETE_CATEGORY_SUCCESS](state) {
    state.success = true;
    state.category = false;
    state.loading = false;
  },
  [GET_CATEGORY](state) {
    state.category = false;
    state.error = false;
    state.loading = true;
  },
  [GET_CATEGORY_ERROR](state, payload) {
    state.error = payload;
    state.category = [];
    state.loading = false;
  },
  [GET_CATEGORY_SUCCESS](state, payload) {
    state.category = payload;
    state.loading = false;
  },

  [GET_CATEGORY_BYID](state) {
    state.categoryById = false;
    state.error = false;
    state.loading = true;
  },
  [GET_CATEGORY_BYID_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_CATEGORY_BYID_SUCCESS](state, payload) {
    state.categoryById = payload;
    state.loading = false;
  },

  [CREATE_CATEGORY](state) {
    state.categoryError = false;
    state.success = false;
    state.formLoading = true;
  },
  [CREATE_CATEGORY_ERROR](state, payload) {
    state.categoryError = payload;
    state.formLoading = false;
  },
  [CREATE_CATEGORY_SUCCESS](state, payload) {
    state.category = payload;
    state.success = true;
    state.formLoading = false;
  },
  updateItem(state, payload) {
    state.company[payload.item] = payload.value;
  },
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Companies/mutations.js